import { makeStyles } from '@material-ui/core'

import LoginWithClassLinkButton from './LoginWithClassLinkButton'
import LoginWithCleverButton from './LoginWithCleverButton'
import LoginWithGoogleButton from './LoginWithGoogleButton'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(2, 0),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}))

type SSOButtonsProps = {
  actualSource?: string
  scid?: number
  disableGoogle?: boolean
  disableClever?: boolean
  disableClassLink?: boolean
  // Google alone takes an invitation: Clever and ClassLink identify an invited
  // student through their own rosters
  inviteToken?: string
  onError?: (message: string) => void
}

const SSOButtons = ({
  actualSource,
  scid,
  disableGoogle = false,
  disableClever = false,
  disableClassLink = false,
  inviteToken,
  onError,
}: SSOButtonsProps) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      {!disableGoogle && (
        <LoginWithGoogleButton
          source={actualSource}
          scid={scid}
          inviteToken={inviteToken}
          onError={onError}
        />
      )}
      {!disableClever && (
        <LoginWithCleverButton
          source={actualSource}
          scid={scid}
        />
      )}
      {!disableClassLink && (
        <LoginWithClassLinkButton
          source={actualSource}
          scid={scid}
        />
      )}
    </div>
  )
}

export default SSOButtons
